export enum MenuKey {
  Booking = 1,
  Travels,
  Expenses,
  Profile,
  Dashboard,
  Users,
  Groups,
  Rules,
  CostCenter,
  Report,
  Settings,
  CustomerSupport,
  BranchCompany,
}

export enum MenuRoles {
  Traveler = 1,
  Approver,
  Admin,
  TravelArranger,
}

export enum MenuDisplay {
  Mobile = 1,
  Desktop,
}

export interface MenuEntry {
  key: MenuKey;
  mainRoute: string;
  nestedRoutes: string[];
  roles: MenuRoles[];
  display: MenuDisplay[];
  iconSrc: string;
  iconSmall: boolean;
  name: string;
  detail: string;
}

const MENU_ENTRIES: MenuEntry[] = [
  {
    key: MenuKey.Booking,
    mainRoute: '/booking',
    nestedRoutes: ['/flights', '/hotels', '/autos'],
    roles: [MenuRoles.Traveler],
    display: [MenuDisplay.Mobile, MenuDisplay.Desktop],
    iconSrc: '/images/booking.svg',
    iconSmall: false,
    name: 'userMenu.bookingTitle',
    detail: 'userMenu.bookingDetail',
  },
  {
    key: MenuKey.Travels,
    mainRoute: '/travelRequested',
    nestedRoutes: [],
    roles: [MenuRoles.Traveler],
    display: [MenuDisplay.Mobile, MenuDisplay.Desktop],
    iconSrc: '/images/mytrips.svg',
    iconSmall: false,
    name: 'userMenu.myTripsTitle',
    detail: 'userMenu.myTripsDetail',
  },
  {
    key: MenuKey.Expenses,
    mainRoute: '/travelsWithExpenses',
    nestedRoutes: ['/expense', '/expenses'],
    roles: [MenuRoles.Traveler],
    display: [MenuDisplay.Mobile, MenuDisplay.Desktop],
    iconSrc: '/images/reports.svg',
    iconSmall: true,
    name: 'userMenu.expensesTitle',
    detail: 'userMenu.expensesDetail',
  },
  {
    key: MenuKey.Profile,
    mainRoute: '/travelerProfile',
    nestedRoutes: [],
    roles: [MenuRoles.Traveler],
    display: [MenuDisplay.Mobile],
    iconSrc: '/images/users.svg',
    iconSmall: true,
    name: 'userMenu.travelerProfileTitle',
    detail: 'userMenu.travelerProfileDetail',
  },
  {
    key: MenuKey.CustomerSupport,
    mainRoute: '/customerSupport',
    nestedRoutes: [],
    roles: [MenuRoles.Traveler],
    display: [MenuDisplay.Mobile],
    iconSrc: '/images/customer-support.svg',
    iconSmall: true,
    name: 'userMenu.customerSupportTitle',
    detail: 'userMenu.customerSupportDetail',
  },
  {
    key: MenuKey.Dashboard,
    mainRoute: '/dashboard',
    nestedRoutes: ['/requestHistory', '/dashboardReports', '/dashboardReports/reportDetail'],
    roles: [MenuRoles.Approver],
    display: [MenuDisplay.Mobile, MenuDisplay.Desktop],
    iconSrc: '/images/dashboard-icon.svg',
    iconSmall: false,
    name: 'userMenu.dashboardTitle',
    detail: 'userMenu.dashboardDetail',
  },
  {
    key: MenuKey.Users,
    mainRoute: '/usersList',
    nestedRoutes: ['/usersForm'],
    roles: [MenuRoles.Admin, MenuRoles.TravelArranger],
    display: [MenuDisplay.Mobile, MenuDisplay.Desktop],
    iconSrc: '/images/check-copy.svg',
    iconSmall: true,
    name: 'userMenu.usersProfilesTitle',
    detail: 'userMenu.usersProfilesDetail',
  },
  {
    key: MenuKey.Groups,
    mainRoute: '/groupList',
    nestedRoutes: ['/group'],
    roles: [MenuRoles.Admin],
    display: [MenuDisplay.Mobile, MenuDisplay.Desktop],
    iconSrc: '/images/people.svg',
    iconSmall: true,
    name: 'userMenu.groupsTitle',
    detail: 'userMenu.groupsDetail',
  },
  {
    key: MenuKey.Rules,
    mainRoute: '/rules',
    nestedRoutes: ['/rule'],
    roles: [MenuRoles.Admin],
    display: [MenuDisplay.Mobile, MenuDisplay.Desktop],
    iconSrc: '/images/polices.svg',
    iconSmall: true,
    name: 'userMenu.rulesTitle',
    detail: 'userMenu.rulesDetail',
  },
  {
    key: MenuKey.CostCenter,
    mainRoute: '/costCenterList',
    nestedRoutes: ['/costCenter'],
    roles: [MenuRoles.Admin],
    display: [MenuDisplay.Mobile, MenuDisplay.Desktop],
    iconSrc: '/images/rules.svg',
    iconSmall: true,
    name: 'userMenu.costCenterTitle',
    detail: 'userMenu.costCenterDetail',
  },
  {
    key: MenuKey.Report,
    mainRoute: '/travelReport',
    nestedRoutes: [],
    roles: [MenuRoles.Admin],
    display: [MenuDisplay.Mobile, MenuDisplay.Desktop],
    iconSrc: '/images/reports.svg',
    iconSmall: true,
    name: 'userMenu.reportsTitle',
    detail: 'userMenu.reportsDetail',
  },
  {
    key: MenuKey.Settings,
    mainRoute: '/settings',
    nestedRoutes: [],
    roles: [MenuRoles.Admin],
    display: [MenuDisplay.Mobile],
    iconSrc: '/images/settings.svg',
    iconSmall: true,
    name: 'userMenu.settingsTitle',
    detail: 'userMenu.settingsDetail',
  },
  // Comentado por que este menu estará en el Admin Tool
  //{
  //   key: MenuKey.BranchCompany,
  //   mainRoute: '/billingCompanyList',
  //   nestedRoutes: ['/billingCompany'],
  //   roles: [MenuRoles.Admin],
  //   display: [MenuDisplay.Mobile, MenuDisplay.Desktop],
  //   iconSrc: '/images/document.svg',
  //   iconSmall: true,
  //   name: 'userMenu.billingCompanyTitle',
  //   detail: 'userMenu.billingCompanyDetail',
  // },
];

export default MENU_ENTRIES;
